// Canonical A-26 fulfillment_source enum + derivation.
// Source of truth: planning/plans/m3-faz3-commerce-spec.md §2.2 CHECK constraint.
// Roadmap mapping: planning/plans/2026-05-29-inventory-skuvault-inspired-roadmap.md §P1A-2.
//
// Wave-15-prep Day 1 (2026-06-02) — consolidated dialect codemod sprint.
// Replaces 3 legacy enum dialects (pexify_owned/partner_stock/vendor_sourced
// + pexify/manufacturer_dropship/partner_dropship + ad-hoc strings) with a
// single canonical 3-value enum that aligns FE → ratified planning SPEC.md.
// No backend schema change (D-14 frozen-point preserved).

export const FULFILLMENT_SOURCES = [
  'pexify_warehouse',
  'manufacturer_dropship',
  'supplier_warehouse_dropship',
] as const

export type FulfillmentSource = (typeof FULFILLMENT_SOURCES)[number]

const LABELS: Record<FulfillmentSource, string> = {
  pexify_warehouse: 'PEXIFY',
  manufacturer_dropship: 'Manufacturer Dropship',
  supplier_warehouse_dropship: 'Supplier Dropship',
}

export function fulfillmentSourceLabel(s: FulfillmentSource): string {
  return LABELS[s]
}

export function deriveFulfillmentSource(
  ownerId: string | null | undefined,
): FulfillmentSource {
  if (!ownerId) return 'pexify_warehouse'
  if (ownerId.startsWith('so2_')) return 'manufacturer_dropship'
  if (ownerId.startsWith('so3_')) return 'supplier_warehouse_dropship'
  return 'pexify_warehouse'
}
